export default {
    "name": "InterchangeScreenManufacturers",
    "kind": "HoudiniQuery",
    "hash": "c1379cb02023d6faed62abcd7d7eef3f839611dc08b3c27fd4395e9cedad2200",

    "raw": `query InterchangeScreenManufacturers($filter: ManufacturerFilter) {
  manufacturers(filter: $filter) {
    id
    name
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "manufacturers": {
                "type": "Manufacturer",
                "keyRaw": "manufacturers(filter: $filter)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "filter": "ManufacturerFilter"
        },

        "types": {
            "ManufacturerFilter": {
                "code": "String",
                "id": "UInt",
                "inventoryTypeId": "Int",
                "name": "String",
                "vehicle": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=9c60460d32ffa7aebe227852232185237cd7b4de5698ced0879ea8fde4f2c0cc";